import { exocad } from '@exocad/webview-embedded';
import { selectLanguage } from 'src/store/session/sessionSelects';
import { useAppSelector } from 'src/hooks/hooks';
import { shallowEqual } from 'react-redux';
import { Language } from 'src/enums/language.enum';


const languageID = exocad.WebviewAPI.LanguageID;
const languageMapper: ReadonlyMap<string, exocad.WebviewAPI.LanguageID> = new Map<string, exocad.WebviewAPI.LanguageID>([
    [Language.English, languageID.English],
    [Language.French, languageID.French],
    [Language.German, languageID.German],
    [Language.Italian, languageID.Italian],
    [Language.Japanese, languageID.Japanese],
    [Language.Korean, languageID.Korean],
    [Language.Portuguese, languageID.Portuguese],
    [Language.Russian, languageID.Russian],
    [Language.Spanish, languageID.Spanish],
    [Language.Turkish, languageID.Turkish],
    [Language.Chinese, languageID.ChineseTraditional],
    [Language.Thai, languageID.Thai]
]);

export function useLanguage() {
    const selectedLanguage = useAppSelector(selectLanguage, shallowEqual);
    const language = languageMapper.get(selectedLanguage);
    return language ?? languageID.English;
}
